import Immutable from 'immutable';
import { handleActions } from 'redux-actions';

const AlertState = Immutable.fromJS({
    alert: {
        style: null,
        message: null
    }
});

const alertReducer = handleActions({
    CLEAN_GLOBAL_MESSAGE: (state, { payload }) => {
        return state.merge({
            alert: {
                style: null,
                message: null,
            }
        })
    },

    SHOW_GLOBAL_ALERT: (state, { payload }) => {
        return state.merge({
            alert: {
                style: 'warning',
                message: payload
            }
        })
    },



}, AlertState);

export default alertReducer;


// WEBPACK FOOTER //
// ./src/reducers/alertReducer.js